/// <amd-module name="TFS/Admin/Groups/Pivots/ServicePrincipals/Redux/ServicePrincipalsPivotSelectors" />
import { SearchStatus } from "TFS/Admin/Groups/Common/Constants";
import { ISearchResultCache, IServicePrincipalsPivotAwareState } from "TFS/Admin/Groups/Common/Contracts";
import { GraphServicePrincipal } from "VSS/Platform/Contracts/Graph";
import { MessageCardSeverity } from "VSSUI/MessageCard";

export function getServicePrincipals(state: IServicePrincipalsPivotAwareState): GraphServicePrincipal[] {
    if (!state || !state.servicePrincipalsState || !state.servicePrincipalsState.data) {
        return [];
    }

    if (state.servicePrincipalsState.data.totalIdentityCount > 0) {
        return state.servicePrincipalsState.data.identities;
    }

    return [];
}

export function fetchMoreDataOnLastRow(state: IServicePrincipalsPivotAwareState): boolean {
    if (!state || !state.servicePrincipalsState || !state.servicePrincipalsState.data) {
        return true;
    }

    return state.servicePrincipalsState.data.moreData;
}

export function getTotalIdentityCount(state: IServicePrincipalsPivotAwareState): number {
    if (!state || !state.servicePrincipalsState || !state.servicePrincipalsState.data) {
        return 0;
    }

    return state.servicePrincipalsState.data.totalIdentityCount;
}

export function getContinuationToken(state: IServicePrincipalsPivotAwareState): string[] | undefined {
    if (!state || !state.servicePrincipalsState || !state.servicePrincipalsState.data) {
        return undefined;
    }

    return state.servicePrincipalsState.data.continuationToken;
}

export function showLoadingPanel(state: IServicePrincipalsPivotAwareState): boolean {
    if (!state || !state.servicePrincipalsState) {
        return true;
    }
    return state.servicePrincipalsState.loading;
}

export function getSearchResult(state: IServicePrincipalsPivotAwareState): ISearchResultCache {
    if (!state || !state.servicePrincipalsState) {
        return {
            keyword: "",
            resultItems: [],
            status: SearchStatus.None,
            hasMore: false
        };
    }
    return state.servicePrincipalsState.searchResult;
}

export function getInitComplete(state: IServicePrincipalsPivotAwareState): boolean {
    if (!state || !state.servicePrincipalsState) {
        return false;
    }
    return state.servicePrincipalsState.initComplete;
}

export function getMessageCardText(state: IServicePrincipalsPivotAwareState): string | undefined {
    if (!state || !state.servicePrincipalsState) {
        return undefined;
    }

    return state.servicePrincipalsState.messageCardText;
}

export function getMessageCardSeverity(state: IServicePrincipalsPivotAwareState): MessageCardSeverity | undefined {
    if (!state || !state.servicePrincipalsState) {
        return undefined;
    }

    return state.servicePrincipalsState.messageCardSeverity;
}
